<template>
  <div id="app">
    <router-view />
    <exception-message-modal :isVisible="exception" :message="exceptionMessage"/>
    <logout-notification-modal :isVisible="isLoggingOut" message="Logout" />
  </div>
</template>

<script>
import { HUB_CONNECTING_EVENT, HUB_CONNECTED_EVENT, HUB_DISCONNECTED_EVENT } from './common/events/eventsSource.js'
import { TIMEOUT_EXCEPTION, CONNECTION_EXCEPTION, SERVER_EXCEPTION } from './common/exceptions/Exceptions.js'
import DisconnectMessageCard from './components/cards/DisconnectMessageCard.vue'
import ExceptionMessageModal from './components/modals/ExceptionMessageModal.vue'
import LogoutNotificationModal from './components/modals/LogoutNotificationModal.vue'
import { mapState } from 'vuex'
export default {
  inject: ['eventBus', 'hub'],
  components : {
    DisconnectMessageCard,
    ExceptionMessageModal,
    LogoutNotificationModal
  },
  computed : {
    ...mapState({
      exception : state => state.app.exception.isCatched,
      exceptionMessage : state => state.app.exception.message 
    })
  },
  data() {
    return {
      isLoggingOut : false
    }
  },
  methods: {
    logout() {
      this.eventBus.$off(HUB_CONNECTING_EVENT, this.disconnectToHubService);
      this.eventBus.$off(HUB_CONNECTED_EVENT, this.showDisconnectedMessageToHub);
      this.eventBus.$off(HUB_DISCONNECTED_EVENT, this.showDisconnectedMessageToHub);
      this.eventBus.$off(TIMEOUT_EXCEPTION, this.handleException);
      this.eventBus.$off(CONNECTION_EXCEPTION, this.handleException);
      this.eventBus.$off(SERVER_EXCEPTION, this.handleException);

      this.$store.commit('auth/SET_LOGOUT_STATE', { });
      this.$router.push('/login'); 
      
    },
    async connectToHubService() {

      let token = this.$store.state.auth.auth.token;
      let restaurantId = this.$store.state.auth.auth.restaurantId;

      this.hub.createHubConnection(token);
      this.$message.loading('Connecting to hub..', 0);
      let isSuccessful = await this.hub.connectToServer();

      if(isSuccessful) {

        await this.hub.registerToGroup(restaurantId);

        await this.hub.registerToServerEvent('sendMessageToClientEvent', (msg) => this.showMessageFromHub(msg));

        await this.hub.registerToServerEvent('sendNewOrderMessageToClientEvent', (msg) => this.showOrderComingFromHub(msg));

        this.hub.onReconnecting(this.reconnectingToHub);

        this.hub.onReconnected(this.reconnectToHub);

        this.hub.onClose(this.showDisconnectedMessageToHub);

        this.$store.commit('hub/SET_HUB_CONNECTION_STATE', { isConnected : true } );

        this.$message.loading('Connected to hub successfully...', 5);
      }
      else {
        this.$message.error('Cannot connect to hub!!!');
      }
      this.$message.destroy();
    },

    async disconnectToHubService() {
      let token = this.$store.state.auth.auth.token;
      let restaurantId = this.$store.state.auth.auth.restaurantId;
      await this.hub.unregisterFromGroup(restaurantId);
    },
    showConnectedMessageToHub() {

    },
    showDisconnectedMessageToHub() {
      
      this.$store.commit('hub/SET_HUB_CONNECTION_STATE', { isConnected : false } );

      this.$notification.open({
        message: 'Hub is disconnected',
        description : 'Notification will not be synchronized! Please reconnect to the hub or update manually!',
        btn : h => {
          return h(
            'a-button',
            {
              props : {
                type : 'primary',
                size : 'small'
              },
              on: {
                click: () => { location.reload() }
              }
            },
            'Reconnect'
          )
        },
        duration : 0
      })
    },
    showMessageFromHub(msg) {
      this.$notification.open({
        message : 'Message from contact center',
        description: msg.message,
        duration : 0
      })
    },

    showOrderComingFromHub(order) {
      //console.log(order)
      this.$notification.open({
        message : 'New order is comming',
        description: '...',
        duration : 10
      })
      this.$store.commit('orderManager/ADD_NEW_ORDER_STATE', order);
    },


    async reconnectToHub() {

      let restaurantId = this.$store.state.auth.auth.restaurantId;

      await this.hub.registerToGroup(restaurantId);

      await this.hub.registerToServerEvent('sendMessageToClientEvent', (msg) => this.showMessageFromHub(msg));

      await this.hub.registerToServerEvent('sendNewOrderMessageToClientEvent', (msg) => this.showOrderComingFromHub(order));

      this.$message.success('Reconnected to hub successfully!', 5);

      this.$message.destroy();

    },

    reconnectingToHub() {
      this.$message.loading('Reconnecting to hub...');
    },

    handleException() {

    }

  },

  created() {
    if(this.$store.state.auth.auth.isLogin) {
      setTimeout(this.logout, 1000*60*60*10);
    }
    this.eventBus.$on(HUB_CONNECTING_EVENT, this.connectToHubService);
    this.eventBus.$on(HUB_CONNECTED_EVENT, this.showConnectedMessageToHub);
    this.eventBus.$on(HUB_DISCONNECTED_EVENT, this.showDisconnectedMessageToHub);
    this.eventBus.$on(TIMEOUT_EXCEPTION, this.handleException);
    this.eventBus.$on(CONNECTION_EXCEPTION, this.handleException);
    this.eventBus.$on(SERVER_EXCEPTION, this.handleException);

  },

  destroyed() {
    this.eventBus.$off(HUB_CONNECTING_EVENT, this.disconnectToHubService);
    this.eventBus.$off(HUB_CONNECTED_EVENT, this.showDisconnectedMessageToHub);
    this.eventBus.$off(HUB_DISCONNECTED_EVENT, this.showDisconnectedMessageToHub);

    this.eventBus.$off(TIMEOUT_EXCEPTION, this.handleException);
    this.eventBus.$off(CONNECTION_EXCEPTION, this.handleException);
    this.eventBus.$off(SERVER_EXCEPTION, this.handleException);
  }
}
</script>

